<script>
    import { getDashboard, apiLoading } from "../../services/store";

    export let projects;
    export let dashboard;

    // let currentProject = 'all';
    let selected

    function getDashboardContent(dashboard, projectID) {
        // currentProject = projectID;
        selected = projectID;
        // console.log('Project', projectID, selected);
        apiLoading.set(true);
        getDashboard(dashboard, projectID);
    }

</script>

<div class="project-selector">
    <div class="select-wrapper">
        <select
            on:change={e => getDashboardContent(dashboard, e.target.value)}
            disabled={$apiLoading}
            class={$apiLoading ? 'loading' : ''}
            bind:value={selected}
        >
            <option value="all">All My Projects</option>
            {#if projects.length > 0}
                {#each projects as project}
                    <option value={project.id}>
                        {project.id} - {project.name} 
                    </option>
                {/each}
            {/if}
        </select>
    </div>
</div>